import React from "react";
import Featured from './assets/image3.jpg';
import Comment from "./Comment";

export default class PostBody extends React.Component {

    constructor(props){
        super(props);
    }

    render() {
        return(
            <div className="post-body">
                <h1 className='singlepost-section-header'>{this.props.title}</h1>
                <img src={this.props.imgUrl} />
                <div dangerouslySetInnerHTML={{__html: this.props.content}}/>
                <Comment />
            </div>
        )
    }
}